module.exports = __webpack_public_path__ + "img/pålestikk_double_ferdig.5d2fbacd.jpg";